import { escapeHtml, readTimelineSteps, replaceWidgetNode, timelineHtml } from './markup';
import { bindRepeatable, dialogStyles as s, itemRow, openFormDialog } from './dialogHelpers';

const stepFields = (step = {}) =>
  `<label class="${s.field}"><span>Title</span>
    <input class="jodit-input mc-tl-title" type="text" placeholder="e.g. Step 1" value="${escapeHtml(
      step.title || '',
    )}" />
  </label>
  <label class="${s.field}"><span>Description</span>
    <textarea class="jodit-input mc-tl-body" rows="2" placeholder="What happens at this point">${escapeHtml(
      step.body || '',
    )}</textarea>
  </label>`;

const stepRow = (step = {}) =>
  itemRow({ label: 'Step', fields: stepFields(step) });

export const openTimelineDialog = (editorInstance, existingNode = null) => {
  const steps = existingNode
    ? readTimelineSteps(existingNode)
    : [{ title: '', body: '' }, { title: '', body: '' }, { title: '', body: '' }];

  const { dialog, form } = openFormDialog(editorInstance, {
    title: existingNode ? 'Edit timeline' : 'Insert timeline',
    submitLabel: existingNode ? 'Update' : 'Insert',
    minWidth: 560,
    errorMessage: 'Add a title or description to at least one step.',
    html: `<p class="${s.hint}">Add events in order. Learners see them as a vertical timeline.</p>
      <div class="${s.list}">${steps.map(stepRow).join('')}</div>
      <button type="button" class="jodit-ui-button ${s.add}">+ Add step</button>`,
    onSubmit: (submittedForm) => {
      const next = [...submittedForm.querySelectorAll(`.${s.row}`)]
        .map((row) => ({
          title: row.querySelector('.mc-tl-title')?.value.trim() || '',
          body: row.querySelector('.mc-tl-body')?.value.trim() || '',
        }))
        .filter((step) => step.title || step.body);
      if (!next.length) {
        return false;
      }
      replaceWidgetNode(editorInstance, existingNode, timelineHtml(next));
      return true;
    },
  });

  bindRepeatable(form, dialog, {
    listSelector: `.${s.list}`,
    rowSelector: `.${s.row}`,
    addSelector: `.${s.add}`,
    makeRow: () => stepRow(),
  });
};

export const getTimelineButton = () => ({
  name: 'mcTimeline',
  tooltip: 'Timeline',
  exec: (editorInstance) => openTimelineDialog(editorInstance),
});
